import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'

import { partialUpperCase } from '../utils/strings'

// TODO: this stuff can be integrated into use modules
export default function useModuleCase() {
  const { i18n } = useTranslation()
  const { brand } = useTheme()

  // FIXME: module title case now defined in theme, can remove the brand check.
  const ignoredLanguages = ['zh']
  const includedBrands = ['rm']
  if (ignoredLanguages.includes(i18n.language) || !includedBrands.includes(brand)) {
    return (text: string) => text
  }

  return partialUpperCase
}
